"use strict";
/**
 * Работа с рамками: диалог определения точек, автоопределение точек
 * Пока что нет идей, куда этот функционал поместить. Теоретически,
 * он может быть нужен не только в редакторе
 */
Fotobook.frame = {
    // Процент от площади рамки. Области с меньшим % точек будут проигнорированы
    _MIN_AREA_PERCENT: 33,

    getAutoPoints(image){
        return new Promise((resolve) => {
            let area = {
                    "n" : 0,
                    "x1" : 0,
                    "x2" : 100,
                    "y1" : 0,
                    "y2" : 100,
                };

            Fotobook.cors.getImage(image).then((cors_image) => {
                let canvas = document.createElement("canvas"),
                    context = canvas.getContext("2d"),
                    w = cors_image.naturalWidth,
                    h = cors_image.naturalHeight,
                    min_frame_area = this._MIN_AREA_PERCENT * w * h / 100,
                    x1,x2,y1,y2,n,
                    imagedata, data,
                    xy_to_idx = function(x,y){
                        return 4*(x+y*w)+3;
                    },
                    linefill_pixel = (x,y) => {
                        let idx = xy_to_idx(x,y);
                        if (data[idx] !== 255){
                            data[idx] = 255;
                            n++;
                            if (x1 > x){
                                x1 = x;
                            }
                            if (x2 < x){
                                x2 = x;
                            }
                            if (y1 > y){
                                y1 = y;
                            }
                            if (y2 < y){
                                y2 = y;
                            }
                            return true;
                        }
                        return false;
                    },
                    linefill = (x,y) => {
                        let idx = xy_to_idx(x,y),
                            xr, xl;
                        if (data[idx] === 255){
                            return;
                        }
                        for (xl = x; xl>=0; xl--){
                            if (!linefill_pixel(xl,y)){
                                xl++;
                                break;
                            }
                        }
                        xl = Math.max(xl,0);
                        for (xr = x+1; xr<w; xr++){
                            if (!linefill_pixel(xr,y)){
                                xr--;
                                break;
                            }
                        }
                        xr = Math.min(xr,w-1);
                        for (var xi=xl; xi<=xr; xi++){
                            if (y>0){
                                linefill(xi,y-1);
                            }
                            if (y<h-1){
                                linefill(xi,y+1);
                            }
                        }
                    };

                canvas.width = w;
                canvas.height = h;
                context.clearRect(0, 0, w, h);
                context.drawImage(cors_image, 0, 0, w, h);

                try {
                    imagedata = context.getImageData(0, 0, w, h);
                    data = imagedata.data;

                    for (let yy=0; yy<h; yy++){
                        for (let xx=0; xx<w; xx++){
                            let idx = xy_to_idx(xx,yy);
                            if (data[idx] !== 255){
                                x1 = x2 = xx;
                                y1 = y2 = yy;
                                n=0;
                                linefill(xx,yy);
                                if ((n > min_frame_area) && (n > area.n)){
                                    area = {
                                        "n"  : n,
                                        "x1" : 100 * Math.max(x1-1, 0) / w,
                                        "x2" : 100 * Math.min(x2+1, w) / w,
                                        "y1" : 100 * Math.max(y1-1, 0) / h,
                                        "y2" : 100 * Math.min(y2+1, h) / h,
                                    };
                                }
                            }
                        }
                    }
                } catch (e){
                    Fotobook.debug("getAutoFramePoints: ", e);
                }
                $(canvas).remove();
            }).catch(
                () => {},
            ).finally(() => {
                resolve(area);
            });
        });
    },
    _request_create_clipart_data_dialog: [
        '<div style="overflow:visible">', // В ИЕ почему-то появляются скроллбары
            '<div class="frame-params-dialog">',
                '<div class="toolbar">',
                    '<div class="info-mark">i</div> ', t("photobook-js-frame-edit-only-on-upload"),
                '</div>',
                '<div class="frame-edit-area">',
                    '<div class="image-containment" style="display:none">',
                        '<div class="image resizable-squares">',
                            '<svg class="placeholder" width="100%" height="100%">',
                                `<image xlink:href="${Fotobook.config.data[Fotobook.Settings.STATIC_DEFAULT_FOTO_PLACEHOLDER]}" width="100%" height="100%" preserveAspectRatio="xMidYMid slice" />`,
                            '</svg>',
                            '<svg class="stroke-svg" width="100%" height="100%">',
                                '<rect class="stroke" width="100%" height="100%">',
                            '</svg>',
                            '<div class="text text-fit-to-parent">',
                                t("photobook-js-please-edit-frame-points"),
                            '</div>',
                        '</div>',
                    '</div>',
                    '<img src="{url}" alt="" class="frame rotate-{angle}" style="{size-attr}:100%;">',
                '</div>',
            '</div>',
        '</div>',
    ].join(""),
    /**
     * Выставляет фокус на необходимом элементе внутри диалога. По дефолту: на кнопке подтверждения.
     *
     * @param {*} $dialog
     * @param {*} $button
     */
    dialogFocusOn($dialog, $button) {
        if (!$button) {
            $button = $dialog.parents('.fotobook-dialog').find('.fotobook-dialogbutton-resolve').first();
        }
        if ($button.length) {
            $button.focus();
        }
    },
    getPoints(e){
        return new Promise((resolve, reject) => {
            let dialog_size = 600,
                content = this._request_create_clipart_data_dialog.supplant({
                    "url" : e.getAttribute("src"),
                    "size-attr" : (e.naturalWidth > e.naturalHeight ? "width" : "height"),
                }),
                $dialog = Fotobook.dialog.confirm(content, {
                    "title" : t("photobook-js-frame-points-dialog-title"),
                    "width" : dialog_size + 26,
                    "noClose": true,
                    "buttonResolve" : t("photobook-js-buttonsOk"),
                    "buttonReject" : t("photobook-js-buttonsCancel"),
                }),
                $frame = $dialog.find(".frame"),
                $image = $dialog.find(".image"),
                frame_box, frame_position;

            // несколько диалогов подряд, фикс для фокуса на нужных кнопках
            setTimeout(() => {
                this.dialogFocusOn($dialog);
            }, 0);

            $dialog.then(() => {
                const image_box = $image[0].getBoundingClientRect(),
                    x1 = Math.min(Math.max(0, 100*(image_box.left - frame_box.left)/frame_box.width), 90),
                    x2 = Math.max(x1, Math.min(100*(image_box.right - frame_box.left)/frame_box.width, 100)),
                    y1 = Math.min(Math.max(0, 100*(image_box.top - frame_box.top)/frame_box.height), 90),
                    y2 = Math.max(x1, Math.min(100*(image_box.bottom - frame_box.top)/frame_box.height, 100));

                resolve({
                    x1,
                    x2,
                    y1,
                    y2,
                });
            }).catch(reject);

            this.getAutoPoints(e).then((points) => {
                if (!points.n) {
                    const $alertDialog = Fotobook.dialog.alert(t("photobook-js-incorrectFrameWarning"), {
                        "title": t("photobook-js-frame-points-dialog-title"),
                        "width": 400,
                    });
                    // у нас в итоге 3 диалога друг на друге, это - фикс для фокуса на кнопке последнего
                    setTimeout(() => {
                        this.dialogFocusOn($alertDialog);
                    }, 0);
                }
                // В хроме без timeout высота рамки получается 0
                setTimeout(() => {
                    frame_box = $frame[0].getBoundingClientRect(),
                        frame_position = $frame.position(),

                        $image.css({
                            "top" : frame_box.height*points.y1/100 + "px",
                            "left" : frame_box.width*points.x1/100 + "px",
                            "width" : (frame_box.width * (points.x2 - points.x1) / 100) + "px",
                            "height" : (frame_box.height * (points.y2 - points.y1)/100) + "px",
                        });

                    $dialog.find(".image-containment").css({
                        "left" : frame_position.left + "px",
                        "top" : frame_position.top + "px",
                        "width" : frame_box.width + "px",
                        "height" : frame_box.height + "px",
                        "display" : "",
                    });

                    Fotobook.textFitToParent.call($image);

                    $image.resizable({
                        "handles": "all",
                        "containment": "parent",
                        "start": function(event, ui){
                            $(event.originalEvent.originalEvent.target).addClass("active-handle");
                        },
                        "stop": function(event, ui){
                            ui.element.find(".active-handle").removeClass("active-handle");
                        },
                        "resize" : function(event, ui){
                            Fotobook.textFitToParent.call(ui.element);
                        },
                    });
                }, 0);
            });
        });
    },
};
